export default "__VITE_ASSET__s2dt2SiH__"